import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { resolveEffectiveRole } from '../../lib/roleUtils'

/**
 * 모바일 전용 권한 라우트 가드
 * - 인증 실패: /mobile/qr-login 으로 리다이렉트 (모바일 컨텍스트 유지)
 * - 권한 실패: /mobile/home 으로 리다이렉트 + 토스트 경고 없이 조용히 차단
 *
 * @param {React.ReactElement} children - 보호할 컴포넌트
 * @param {string[]} allowedRoles - 허용된 user_type 목록 (빈 배열이면 인증만 확인)
 *
 * NOTE: staff 역할은 mold_developer와 동일 권한으로 처리 (auth.js와 일관)
 */
export default function MobileProtectedRoute({ children, allowedRoles = [] }) {
  const { isAuthenticated, user } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/mobile/qr-login" replace />
  }

  if (allowedRoles.length > 0 && user) {
    // Phase IU M-1: active_role 우선 (양쪽 capability 협력사 RoleChooserModal 전환 반영)
    // 관리자 (system_admin/mold_developer/staff) 는 user_type 그대로 사용
    // 협력사 (plant/maker) 는 active_role 우선 — RoleChooserModal 선택값 반영
    // 2026-07-08 (P3): 인라인 판정 → roleUtils.resolveEffectiveRole SSoT (서버 auth.js:104 미러, 동작 동일)
    const effectiveRole = resolveEffectiveRole(user)
    if (!allowedRoles.includes(effectiveRole)) {
      return <Navigate to="/mobile/home" replace />
    }
  }

  return children
}
